export const SET_PAYMENT_TOKEN_DATA = 'SET_PAYMENT_TOKEN_DATA'
export const SET_PAYMENT_TOKEN_ERROR = 'SET_PAYMENT_TOKEN_ERROR'
export const SET_PAYMENT_TOKEN_PROCESSING = 'SET_PAYMENT_TOKEN_PROCESSING'
export const RESET_PAYMENT_TOKEN_DATA = 'RESET_PAYMENT_TOKEN_DATA'
export const SET_PAYMENT_IFRAME_INITIALIZED = 'SET_PAYMENT_IFRAME_INITIALIZED'
export const SET_PAYMENT_IFRAME_LANGUAGE = 'SET_PAYMENT_IFRAME_LANGUAGE'
export const SET_PAYMENT_BILLING_DATA = 'SET_PAYMENT_BILLING_DATA'

export function setPaymentTokenProcessing (value) {
  return {
    type: SET_PAYMENT_TOKEN_PROCESSING,
    payload: value,
  }
}

export function setPaymentTokenError (data, processing = false) {
  return {
    type: SET_PAYMENT_TOKEN_ERROR,
    payload: { data, processing },
  }
}

export function setPaymentTokenData (data, processing = false) {
  return {
    type: SET_PAYMENT_TOKEN_DATA,
    payload: { data, processing },
  }
}

export function resetPaymentTokenData () {
  return {
    type: RESET_PAYMENT_TOKEN_DATA,
  }
}

export function setPaymentIframeInitialzed (value) {
  return {
    type: SET_PAYMENT_IFRAME_INITIALIZED,
    payload: value,
  }
}

export function setPaymentIframeLanguage (value) {
  return {
    type: SET_PAYMENT_IFRAME_LANGUAGE,
    payload: value,
  }
}

export function setPaymentBillingData (data) {
  return {
    type: SET_PAYMENT_BILLING_DATA,
    payload: data,
  }
}
